/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_Sent_DescriptionInputs */

const fr_auth_forgot_sent_description = /** @type {(inputs: Auth_Forgot_Sent_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si cette adresse correspond à un compte, vous recevrez un lien valable 30 minutes.`)
};

const en_auth_forgot_sent_description = /** @type {(inputs: Auth_Forgot_Sent_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If this address matches an account, you will receive a link valid for 30 minutes.`)
};

/**
* | output |
* | --- |
* | "If this address matches an account, you will receive a link valid for 30 minutes." |
*
* @param {Auth_Forgot_Sent_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_sent_description = /** @type {((inputs?: Auth_Forgot_Sent_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_Sent_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_sent_description(inputs)
	return fr_auth_forgot_sent_description(inputs)
});